"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.totalCallsTranslations = {
    "en": {
        totalCalls: "Total Сalls",
        calls: "Calls",
        immediatelyConnected: "Immediately connected",
        connectedAfterQueueing: "Connected after queueing",
        routedAway: "Routed away by pressing a digit",
        timedOut: "Timed out",
        abandoned: "Abandoned",
        failedDueTo: "Failed due to max callers",
        immediatelyConnectedTooltip: "Call was immediately answered after the initial greeting",
        connectedAfterQueueingTooltip: "Call was connected after waiting in queue",
        routedAwayTooltip: "Call was routed away after caller selected a menu option",
        timedOutTooltip: "Call was handled according to the timeout action or terminated by call back timeout",
        abandonedTooltip: "Call was abandoned by the caller",
        failedDueToTooltip: "Call was routed away due to exceeding the maximum callers on hold",
        noData: "No data",
        available: "available",
        other: "Other",
        otherTooltip: "Calls categorized for any other reason",
    },
    "de": {
        failedDueTo: "Wegen Anrufer-Höchstzahl gescheitert",
        immediatelyConnectedTooltip: "Anruf wurde sofort nach der ersten Begrüßung entgegengenommen",
        connectedAfterQueueing: "Verbunden nach Wartezeit",
        timedOut: "Zeitüberschreitung",
        connectedAfterQueueingTooltip: "Anruf wurde nach Warten in der Warteschlange verbunden",
        available: "verfügbar",
        failedDueToTooltip: "Anruf wurde fortgeleitet, weil die maximale Anruferzahl in der Warteschleife überschritten wurde",
        routedAwayTooltip: "Anruf wurde nach Wählen einer Menüoption durch den Anrufer fortgeleitet",
        immediatelyConnected: "Sofort verbunden",
        totalCalls: "Gesamtzahl der Anrufe",
        calls: "Anrufe",
        noData: "Keine Daten",
        timedOutTooltip: "Anruf wurde gemäß der Zeitüberschreitungsaktion bearbeitet",
        abandoned: "Abgebrochen",
        routedAway: "Durch Drücken einer Zahl fortgeleitet",
        abandonedTooltip: "Anruf wurde vom Anrufer abgebrochen",
        other: "Andere",
        otherTooltip: "Anrufe, die aus einem anderen Grund kategorisiert wurden",
    },
    "nl": {
        failedDueTo: "Niet gelukt door maximaal aantal bellers",
        immediatelyConnectedTooltip: "Oproep is onmiddellijk beantwoord na de initiële begroeting",
        connectedAfterQueueing: "Verbonden na wachtrij",
        timedOut: "Verbroken",
        connectedAfterQueueingTooltip: "De oproep is verbonden na de wachttijd",
        available: "beschikbaar",
        failedDueToTooltip: "De oproep is weggerouteerd omdat het maximale aantal bellers in de wacht werd overschreden",
        routedAwayTooltip: "Oproep is weggerouteerd nadat de beller een menu-optie selecteerde",
        immediatelyConnected: "Onmiddellijk verbonden",
        totalCalls: "Totale oproepen",
        calls: "Oproepen",
        noData: "Geen gegevens",
        timedOutTooltip: "Oproep is afgehandeld in overeenstemming met de time-outactie of beëindigd door de terugbeltime-out",
        abandoned: "Afgebroken",
        routedAway: "Doorsturen door nummer in te drukken",
        abandonedTooltip: "De oproep is аfgebroken door de beller",
        other: "Andere",
        otherTooltip: "Oproepen gecategoriseerd om een ​​andere reden",
    },
    "it": {
        failedDueTo: "Fallita a causa di massimo numero utenti",
        immediatelyConnectedTooltip: "La chiamata ha subito ricevuto risposta dopo il saluto iniziale",
        connectedAfterQueueing: "Collegata dopo attesa",
        timedOut: "Scaduta",
        connectedAfterQueueingTooltip: "La chiamata è stata connessa dopo l'attesa in coda",
        available: "disponibile",
        failedDueToTooltip: "Chiamata inoltrata perché è stato superato il numero massimo di chiamanti in attesa",
        routedAwayTooltip: "La chiamata è stata inoltrata dopo che il chiamante ha selezionato un'opzione del menu",
        immediatelyConnected: "Collegata immediatamente",
        totalCalls: "Chiamate in totale",
        calls: "Chiamate",
        noData: "Nessun dato",
        timedOutTooltip: "La chiamata è stata gestita in accordo con l'azione per timeout",
        abandoned: "Abbandonata",
        routedAway: "Dirottata premendo un numero",
        abandonedTooltip: "Chiamata abbandonata dal chiamante",
        other: "Altro",
        otherTooltip: "Chiamate classificate per qualsiasi altro motivo",
    },
    "fr": {
        failedDueTo: "Échec dû au nombre maximum d'appelants",
        immediatelyConnectedTooltip: "L'appel a été immédiatement pris après les salutations initiales",
        connectedAfterQueueing: "Connecté après avoir fait la file",
        timedOut: "Interrompu",
        connectedAfterQueueingTooltip: "L'appel a été connecté après avoir attendu dans la queue",
        available: "disponible",
        failedDueToTooltip: "L'appel a été réacheminé en raison du dépassement du nombre maximal d'appelants en attente",
        routedAwayTooltip: "L'appel a été réacheminé après que l'appelant a sélectionné une option du menu",
        immediatelyConnected: "Connecté directement",
        totalCalls: "Nombre total d'appels",
        calls: "Appels",
        noData: "Aucune donnée",
        timedOutTooltip: "L'appel a été géré selon l'action de temporisation",
        abandoned: "Abandonné",
        routedAway: "Acheminé en appuyant sur un chiffre",
        abandonedTooltip: "L'appel a été abandonné par l'appelant",
        other: "Autre",
        otherTooltip: "Appels classés pour toute autre raison",
    },
    "es": {
        failedDueTo: "Error por exceso de llamadas",
        immediatelyConnectedTooltip: "La llamada fue contestada de inmediato después del saludo inicial",
        connectedAfterQueueing: "Conectado después de estar en la cola",
        timedOut: "Tiempo agotado",
        connectedAfterQueueingTooltip: "La llamada se conectó después de esperar en la cola",
        available: "disponible",
        failedDueToTooltip: "La llamada fue desviada debido a que se sobrepasó el número máximo de llamadas en espera",
        routedAwayTooltip: "La llamada fue desviada después que la persona que llamó escogió una opción del menú",
        immediatelyConnected: "Conectado de inmediato",
        totalCalls: "Total de llamadas",
        calls: "Llamadas",
        noData: "No hay información",
        timedOutTooltip: "La llamada fue manejada de cuerdo a las medidas de tiempo de espera",
        abandoned: "Abandonado",
        routedAway: "Desviado al presionar un dígito",
        abandonedTooltip: "La llamada fue abandonada por la persona que llamó",
        other: "Otro",
        otherTooltip: "Llamadas clasificadas por cualquier otro motivo",
    },
    "ja": {
        failedDueTo: "発信者数が最大のため失敗した",
        immediatelyConnectedTooltip: "通話は最初のグリーティングのあと、即座に回答されました",
        connectedAfterQueueing: "キューイング後に接続した",
        timedOut: "タイムアウトした",
        connectedAfterQueueingTooltip: "通話は,順番待ちの後に接続されました。",
        available: "使用可能",
        failedDueToTooltip: "通話は保留中の発信者の上限を超えたため転送されました",
        routedAwayTooltip: "通話は発信者がメニューオプションを選択したあと、ルーティングされました",
        immediatelyConnected: "即時接続した",
        totalCalls: "合計通話数",
        calls: "通話",
        noData: "データなし",
        timedOutTooltip: "通話はタイムアウト手順に従って処理されました",
        abandoned: "放棄された",
        routedAway: "数字を押してルーティングした",
        abandonedTooltip: "通話は発信者によって放棄されました",
        other: "その他の",
        otherTooltip: "その他の理由で分類された通話",
    },
    "en-GB": {
        failedDueTo: "Failed due to max callers",
        immediatelyConnectedTooltip: "Call was immediately answered after the initial greeting",
        connectedAfterQueueing: "Connected after queuing",
        timedOut: "Timed out",
        connectedAfterQueueingTooltip: "Call was connected after waiting in queue",
        available: "available",
        failedDueToTooltip: "Call was routed away due to exceeding the maximum callers on hold",
        routedAwayTooltip: "Call was routed away after caller selected a menu option",
        immediatelyConnected: "Immediately connected",
        totalCalls: "Total Calls",
        calls: "Calls",
        noData: "No data",
        timedOutTooltip: "Call was handled according to the timeout action",
        abandoned: "Abandoned",
        routedAway: "Routed away by pressing a digit",
        abandonedTooltip: "Call was abandoned by the caller",
        other: "Other",
        otherTooltip: "Calls categorized for any other reason",
    },
    "ru": {
        totalCalls: "Всего Звонков",
        calls: "Звонки",
        immediatelyConnected: "Сразу соединены",
        connectedAfterQueueing: "Соединены после ожидания",
        routedAway: "Перенаправлены после нажатия кнопки",
        timedOut: "Не дождались",
        abandoned: "Отмененные",
        failedDueTo: "Завершены из-за максимального количества звонящих",
        immediatelyConnectedTooltip: "На звонок сразу ответили после приветствия",
        connectedAfterQueueingTooltip: "Звонок был отвечен после ожидания в очереди",
        routedAwayTooltip: "Звонок был перенаправлен после того, как абонент нажал кнопку из меню",
        timedOutTooltip: "Звонок был обработан в соответствии со сроком ожидания или отменен по истечению ожидания обратного вызова",
        abandonedTooltip: "Звонок был прекращен абонентом",
        failedDueToTooltip: "Звонок был прекращен, так как превышено количество абонентов в очереди ожидания",
        noData: "Нет данных",
        available: "доступных",
        other: "Другие",
        otherTooltip: "Звонки категоризированы по любой другой причине",
    },
};
